import axios from 'axios';

class Ajax {

    prefix = 'prebook_';

    setPrefix = (prefix) => {
        this.prefix = prefix;
        return this;
    }

    instance = ( action = '' ) => {
        let source = typeof prebook_admin !== 'undefined' ? prebook_admin : prebook || {};
        action = ( this.prefix || 'prebook_' ) + action;

        const getNonce = () => {
            return source.nonce || '';
        }

        return axios.create({
            baseURL: (source?.url?.ajax || '/wp-admin/admin-ajax.php') + '?nonce=' + getNonce() + '&action=' + action,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8',
            },
        });
    }

    request = async (action, data = {}, method = 'post')  => {
        const instance = this.instance;

        if (method.toLowerCase() === 'get') {
            return await instance(action).get('', {params: data}).then(response => response.data);
        }

        return await instance(action).post('', data).then(response => response.data);
    }

    get = async (action, data = {}) => {
        return await this.request(action, data, 'get');
    }

    post = async (action, data = {}) => {
        return await this.request(action, data, 'post');
    }
}

export default new Ajax;